import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    diensten: [
      { name: 'Appartement Renovatie', path: '/diensten#appartement' },
      { name: 'Badkamer Verbouwing', path: '/diensten#badkamer' },
      { name: 'Keuken Renovatie', path: '/diensten#keuken' },
      { name: 'Complete Renovatie', path: '/diensten' }
    ],
    projecten: [
      { name: 'Recent Werk', path: '/photos' },
      { name: 'Voor & Na', path: '/photos' },
      { name: 'Portfolio', path: '/photos' }
    ],
    bedrijf: [
      { name: 'Over Ons', path: '/about' },
      { name: 'Werkwijze', path: '/about' },
      { name: 'Testimonials', path: '/' },
      { name: 'Contact', path: '/contact' }
    ],
    contact: [
      { name: 'Offerte Aanvragen', path: '/contact' },
      { name: 'Bel Ons', path: '/contact' },
      { name: 'Email', path: '/contact' }
    ]
  };

  const socialLinks = [
    { icon: 'ri-instagram-line', url: 'https://www.instagram.com/ngp.renovatieprojecten', label: 'Instagram' },
    { icon: 'ri-facebook-fill', url: 'https://www.facebook.com/profile.php?id=61582254384826', label: 'Facebook' }
  ];

  return (
    <footer className="bg-white pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              Diensten
            </h3>
            <ul className="space-y-3">
              {footerLinks.diensten.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              Projecten
            </h3>
            <ul className="space-y-3">
              {footerLinks.projecten.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              Bedrijf
            </h3>
            <ul className="space-y-3">
              {footerLinks.bedrijf.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-map-pin-line mt-0.5 text-gray-400"></i>
                Adelaarstraat 55 B301, Merksem 2170
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-phone-line text-gray-400"></i>
                <a href="tel:0460940222" className="hover:text-gray-900 transition-colors cursor-pointer">0460 94 02 22</a>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-mail-line text-gray-400"></i>
                <a href="mailto:ngp.renovatieprojecten@gmail.com" className="hover:text-gray-900 transition-colors cursor-pointer">ngp.renovatieprojecten@gmail.com</a>
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-600">
                <i className="ri-file-list-line text-gray-400"></i>
                BTW: BE1023188662
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 pt-8 border-t border-gray-100">
          <div>
            <div className="flex items-baseline gap-3 mb-3">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900" style={{ fontFamily: 'serif' }}>
                NGP
              </h2>
              <span className="text-xl lg:text-2xl font-light text-gray-600">
                Renovatieproject
              </span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-16 h-px bg-gray-300"></div>
              <p className="text-xs text-gray-500">
                © {currentYear} NGP Renovatieproject
              </p>
            </div>
          </div>

          <div className="flex flex-col items-start lg:items-end gap-4">
            <p className="text-xs text-gray-500">
              © {currentYear} NGP Renovatieproject. Alle rechten voorbehouden.
            </p>
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-gray-900 text-white flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;